import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import RegisterPage from './RegisterPage';
import LoginPage from './LoginPage';
import ForgotPasswordPage from './ForgotPasswordPage';
import EmailSentPage from './EmailSentPage';
import ResetPasswordPage from './ResetPasswordPage';
import SignatureSetupPage from './SignatureSetupPage';
import SignatureVerifyPage from './SignatureVerifyPage';
import WelcomePage from './WelcomePage';
import OAuthCallbackPage from './OAuthCallbackPage';

export default function AuthRoutes() {
  const auth = useAuthContext();

  return (
    <>
      <Routes>
        <Route path="register" element={<RegisterPage onRegister={auth.register} />} />
        <Route path="login" element={<LoginPage onLogin={auth.login} />} />
        <Route path="callback" element={<OAuthCallbackPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="email-sent" element={<EmailSentPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="signature-setup" element={<SignatureSetupPage />} />
        <Route path="signature-verify" element={<SignatureVerifyPage />} />
        <Route path="welcome" element={<WelcomePage />} />
        <Route path="*" element={<Navigate to="register" replace />} />
      </Routes>
    </>
  );
}
